import { cn } from "@loot-os/ui/lib/utils";
import type { ReactNode } from "react";

/**
 * Box or item artwork, with a placeholder for the empty `imageUrl`s that seed
 * data and half-finished drafts are full of.
 *
 * `alt` defaults to empty because most uses are decorative — the name sits
 * beside the image in the same row or card, so announcing it twice is noise.
 */
export function BoxImage({
  src,
  alt = "",
  className,
  fallback,
}: {
  src: string;
  alt?: string;
  className?: string;
  /** Centered on the muted placeholder when `src` is empty. */
  fallback?: ReactNode;
}) {
  if (!src) {
    return (
      <span aria-hidden className={cn("flex items-center justify-center bg-muted", className)}>
        {fallback}
      </span>
    );
  }
  return <img src={src} alt={alt} className={className} loading="lazy" />;
}
